<template>
  <div class="input-multi-select">
    <div class="row">
      <div class="col-6">
        <div class="input-multi-select__label">Available {{ label || 'Options' }} ({{ filteredAvailableOptions.length }})</div>
        <input class="input-multi-select__filter mb-2" type="text" v-model="filterAvailableString" placeholder="Search">
      </div>
      <div class="col-6">
        <div class="input-multi-select__label">Selected {{ label || 'Options' }} ({{ value.length }})</div>
        <input class="input-multi-select__filter mb-2" type="text" v-model="filterSelectedString" placeholder="Search">
      </div>
      <div class="col-6">
        <div class="input-multi-select__options">
          <div
            class="input-multi-select__option"
            v-for="option in filteredAvailableOptions"
            :key="option.value"
            @click="selectOption(option.value)"
          >{{ option.label }}</div>
        </div>
      </div>
      <div class="col-6">
        <draggable v-model="selectedOptions" class="input-multi-select__selected">
          <div 
            class="input-multi-select__selected-option"
            v-for="option in filteredSelectedOptions"
            :key="option.value"
            @click="unselectOption(option.value)"
          >{{ option.label }}</div>
        </draggable>
      </div>
    </div>
  </div>
</template>
<script>
import { filter } from 'lodash'
import Draggable from 'vuedraggable'
export default {
  components: { Draggable },

  props: ['options', 'value', 'label'],

  data () {
    return {
      filterAvailableString: '',
      filterSelectedString: '',
    }
  },

  computed: {
    filteredAvailableOptions () {
      const options = filter(this.options, option => {
        // Initially filter out already selected values
        if (this.selectedOptionValues.includes(option.value)) {
          return false
        }

        // Then filter based on the filter string
        if (this.filterAvailableString.length) {
          return option.label.toLowerCase().includes(this.filterAvailableString.toLowerCase())
        } else {
          return true
        }
      })

      return options.sort((a, b) => {
        return Intl.Collator(undefined, { numeric: true, sensitivity: "base" }).compare(a.label, b.label)
      })
    },

    selectedOptions: {
      get () {
        // Use the order of selectedOptionValues rather than options, allows draggable to work
        let selectedOptions = []
        this.selectedOptionValues.forEach(selectedOptionValue => {
          const selectedOption = _.find(this.options, option => {
            return option.value === selectedOptionValue
          })

          if (selectedOption) {
            selectedOptions.push(selectedOption)
          }
        })
        return selectedOptions
      },
      set (selectedOptions) {
        this.$emit('input', selectedOptions.map(option => option.value))
      }
    },

    filteredSelectedOptions () {
      return filter(this.selectedOptions, option => {
        // Initially filter out already selected values
        // if (this.selectedOptionValues.includes(option.value)) {
        //   return false
        // }

        // Then filter based on the filter string
        if (this.filterSelectedString.length) {
          return option.label.toLowerCase().includes(this.filterSelectedString.toLowerCase())
        } else {
          return true
        }
      })
    },

    selectedOptionValues () {
      return this.value
    }
  },

  methods: {
    selectOption (value) {
      if (!this.selectedOptionValues.includes(value)) {
        this.selectedOptionValues.push(value)
        this.$emit('input', this.selectedOptionValues)
      }
    },

    unselectOption (value) {
      let newSelectedOptionValues = filter(this.selectedOptionValues, selectedOptionValue => {
        return selectedOptionValue === value ? false : true
      })
      this.$emit('input', newSelectedOptionValues)
    }    
  }

}
</script>
<style lang="scss">
.input-multi-select {
  border-radius: 3px;
  border: 1px solid rgba(96, 125, 159, 0.25);
  background-color: #fbfcfe;
  box-shadow: inset 0 1px 4px -1px rgba(96, 125, 159, 0.25);
  background-clip: padding-box;
  padding: 15px;
  // display: flex;

  &__filter{
    border: 1px solid #eee;
    border-radius: 4px;
    padding-left: 0.5em;
  }

  &__label {
    font-weight: 300;
    margin-bottom: 0.5em;
  }

  &__options, &__selected {
    // width: 50%;
    border-radius: 4px;
    height: 200px;
    max-height: 200px;
    overflow: auto;
    border: 1px solid #eee;
    padding: 5px 5px 0;
  }

  &__option, &__selected-option {
    cursor: pointer;

    &:hover {
      background-color: #eee;
    }
  }
}
</style>